import request from '@/api/httpRequest2'

// 获取收支统计数据
export function getBalanceStatistics() {
  return request({
    url: '/klgeek/statistics/balance',
    method: 'get'
  })
}

// 获取图表统计数据
export function getChartStatistics(timeRange) {
  return request({
    url: '/klgeek/statistics/chart',
    method: 'get',
    params: {
      timeRange
    }
  })
} 